import { useEffect, useState } from 'react';
import { IButtonProps } from './interface';

// Components
import BaseButton from './components/BaseButton';
import BaseAnchor from './components/BaseAnchor';
import BaseLink from './components/BaseLink';
import ExternalModal from '../../../components/ExternalModal';

// Utils
import store from 'store';
import { config } from '../../../utils/config';
import validURL from '../../../utils/validURL';
import useToggle from '../../../utils/hooks/useToggle';

// Redux
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { redirectSSOAsync, selectLoading } from '../../../slices/ssoSlice';

const Button = (props: IButtonProps) => {
    const { disabled = false, href, target, onClick, callBackHref } = props;
    const dispatch = useAppDispatch();

    const token = store.get(config.user.authToken);
    const ssoLoadingSelector = useAppSelector(selectLoading);

    const [modalOpen, toggleModal] = useToggle();
    const [ssoButtonLoading, toggleSsoButtonLoading] = useState(false);

    const _onClick = (e: any) => {
        e.preventDefault();

        if (props.stopPropagation) {
            e.stopPropagation();
        }

        if (!disabled) {
            if (onClick) onClick();
            if (href) {
                if (validURL(href)) {
                    if (target === '_blank') {
                        window.open(href, '_blank');
                    } else {
                        (window as Window).location = href;
                    }
                } else {
                    (window as Window).location = href;
                }
            }
        }
    };

    const ssoLogin = (href: string) => {
        toggleSsoButtonLoading(true);
        dispatch(redirectSSOAsync(href));
    };

    useEffect(() => {
        if (!ssoLoadingSelector) {
            toggleSsoButtonLoading(false);
        }
    }, [ssoLoadingSelector]);

    if (href) {
        if (validURL(href)) {
            // const { host } = new URL(href);
            const host = href;

            if (host.includes('iqos.ro') && token && host !== config.path.socialMedia.facebook) {
                // SSO for buttons that redirects to iqos.ro
                return (
                    <BaseButton
                        {...props}
                        onClick={() => {
                            onClick && onClick();
                            (window as Window).location = href;
                        }}
                    />
                );
            } else if (
                (!host.includes('iqos.ro/') &&
                    !host.includes('iqos-on') &&
                    !host.includes('bit.ly')) ||
                host === config.path.socialMedia.facebook
            ) {
                // External link modal for sites that aren't iqos.ro
                return (
                    <>
                        <BaseButton
                            {...props}
                            onClick={() => {
                                toggleModal();
                                onClick && onClick();
                            }}
                        />

                        <ExternalModal
                            externalRoute={href}
                            toggleModal={toggleModal}
                            modalOpen={modalOpen}
                            callBackHref={callBackHref}
                        />
                    </>
                );
            } else {
                // Other cases (buttons on <PublicRoute> pages for example)
                return <BaseAnchor {...props} />;
            }
        } else {
            return <BaseLink {...props} />;
        }
    } else {
        return <BaseButton {...props} onClick={(e) => _onClick(e)} />;
    }
};

export default Button;
